module.exports = __WEBPACK_EXTERNAL_MODULE_262__;


//////////////////
// WEBPACK FOOTER
// external "weaDocDetail"
// module id = 262
// module chunks = 1